// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1PFww","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2E5Is"};